<template>
  <div class="main">
    <a-form id="formLogin" class="user-layout-login">
      <a-form-item>
        <a-input size="large" type="text" placeholder="账号" v-model="username">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          type="password"
          autocomplete="false"
          placeholder="密码"
          v-model="password"
        >
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-item>

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loading"
          @click="login"
        >确定</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  layout: 'user',
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      el: [],
      authority: []
    }
  },
  methods: {
    setCookie (name, value, expiredays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    },
    async login () {
      if (!this.username || !this.password) {
        this.$notification['error']({
          message: '错误',
          description: '请填写账号和密码'
        })
        return
      }
      this.loading = true
      try {
        let res = await this.$tkParse.post('/login', {
          username: this.username,
          password: this.password
        })
        this.$tkParse.setSessionToken(res.data.sessionToken)
        let user = await this.$tkParse.getData('/users/me')
        // 通常并非所有用户都可以登录后台
        // if (!user.adminRole) throw new Error('not admin')
        this.$store.commit('setUser', user)
        this.$store.commit('setSessionToken', res.data.sessionToken)
        console.log('token', res.data.sessionToken)
        // const ua = navigator.userAgent.toLowerCase()
        // let sessionToken = res.data.sessionToken
        // document.cookie = `sessionToken=${sessionToken};`
        // if (ua.match(/MicroMessenger/i)) {
        //   this.setCookie('sessionToken', sessionToken, 30)
        //   // 微信浏览器 将token在cookie中放一份 在loalStorage中关闭浏览器会被清除
        //   // const expire = new Date((new Date()).getTime() + 30 * 24 * 60 * 60000) // 有效期30天
        //   // document.cookie = `sessionToken=${sessionToken};expires=${expire.toGMTString()}`
        // }
        // if (user.adminRole === 'finance') {
        //   window.location.replace('/product/finishProduct')
        // } else {
        //   window.location.replace('/')
        // }
        if (Object.keys(this.$store.state.user).indexOf('authority') === -1) {
          alert('您还没有任何权限，请联系管理员')
          this.$tkParse.setSessionToken(null)
          this.$store.commit('setUser', null)
          this.$store.commit('setSessionToken', null)
          window.location.reload()
        } else { window.location.replace('/') }
      } catch (e) {
        this.$notification['error']({
          message: '无法登录',
          description: '账号或密码错误'
        })
        this.$tkParse.setSessionToken(null)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-layout-login {
    label {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .item-icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
</style>
